import React, { useContext, useState, useEffect, useRef } from 'react'
import Cookies from '@/lib/cookies'
import { useRouter } from 'next/router'

const CityContext = React.createContext()

export function CityProvider({ children, city: initialCity, needSetCookie, areas, cities }) {
    const router = useRouter()
    const isFirstLoad = useRef(true)

    const [city, setCity] = useState(initialCity)

    const setCityCookie = (city) => {
        setCity(city)
        Cookies.set('atl_city', JSON.stringify(city), {
            expires: new Date(Date.now() + 3600 * 1000 * 24 * 365),
        })
    }

    useEffect(() => {
        needSetCookie && setCityCookie(initialCity)
    }, [])

    useEffect(() => {
        if (isFirstLoad.current) {
            isFirstLoad.current = false
            return
        }

        if (!city || !cities || !Array.isArray(cities)) return

        const { asPath } = router
        let newPath = asPath

        // slug'и всех городов
        const citySlugs = cities.map(c => c.slug).filter(Boolean)

        // Разбиваем путь и убираем пустые элементы
        const pathParts = asPath.split('/').filter(Boolean)

        // Удаляем старый slug города, если он есть
        if (citySlugs.includes(pathParts[0])) {
            pathParts.shift()
        }

        // Добавляем slug города, если он не дефолтный
        if (!city.is_default && city.slug) {
            pathParts.unshift(city.slug)
        }

        // Собираем новый путь
        newPath = '/' + pathParts.join('/')

        // Добавляем query и hash
        const search = window.location.search
        const hash = window.location.hash
        if (search) newPath += search
        if (hash) newPath += hash

        // Проверяем, действительно ли путь изменился
        if (newPath !== asPath) {
            // Проверяем, что страница существует (не отдаёт 500)
            fetch(newPath, { method: 'HEAD' })
                .then((res) => {
                    if (res.ok) {
                        router.push(newPath, undefined, { shallow: false })
                    } else {
                        console.warn(`⚠️ Пропускаем redirect на ${newPath} — код ${res.status}`)
                    }
                })
                .catch((err) => {
                    console.warn(`⚠️ Ошибка при проверке ${newPath}:`, err)
                })
        }
    }, [city.slug])

    return (
        <CityContext.Provider value={{ city, setCityCookie, areas, cities }}>
            {children}
        </CityContext.Provider>
    )
}

export function useCity() {
    return useContext(CityContext)
}
